import { useEffect } from "react";

export default function ContactForm() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://embed.typeform.com/next/embed.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div>
            <div data-tf-live="01JABJRRRARX8WB1WN769XYAEX"></div>
        </div>
    );
}
